import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "ClientDrivingLicence d-flex flex-column" }
const _hoisted_2 = {
  key: 0,
  class: "UpdateInfoForm__title"
}
const _hoisted_3 = {
  key: 0,
  class: "form-field"
}
const _hoisted_4 = {
  key: 1,
  class: "form-field"
}
const _hoisted_5 = {
  key: 2,
  class: "form-field"
}
const _hoisted_6 = {
  key: 3,
  class: "form-field"
}

import {
  computed,
  ref,
  watch,
} from 'vue';
import isEmpty from 'lodash/isEmpty';
import some from 'lodash/some';

import { SelectOption } from '@emobg/web-components/loader';

import DatePicker from '@components/inputs/DatePicker.vue';

import { useStore } from '@store/index';
import { Country } from '@store/Broker/interfaces';
import { AppGetters } from '@store/App/getters';
import { BrokerActions } from '@store/Broker/actions';
import { BrokerGetters } from '@store/Broker/getters';

import { useTranslation } from '@composables/translation';
import { ClientDrivingLicence } from '@api/api.model';
import { getCountriesSelectOptions } from '@/utils/forms.util';
import { EVENTS } from '@consts/events.const';


export default /*@__PURE__*/_defineComponent({
  __name: 'ClientDrivingLicence',
  props: {
  isStandAlone: {
    type: Boolean,
    default: false,
  },
},
  emits: [EVENTS.status],
  setup(__props, { emit: __emit }) {

const { translate } = useTranslation();
const { getters, dispatch } = useStore();
const emit = __emit;

const licenceData = computed<ClientDrivingLicence>(() => getters[BrokerGetters.GetClientDrivingLicenceData]);
const initialLicenceData = licenceData.value;
const countries = computed<Country[]>(() => getters[AppGetters.GetSortedCountries]);
const countriesOptions = computed<SelectOption[]>(() => getCountriesSelectOptions(countries.value));

const isValidForm = ref(true);



const handleValueChange = (prop: string, value: string) => {
  dispatch(BrokerActions.UpdateClientData, { prop, value: value.trim() });
};

watch([licenceData, isValidForm], ([data, isValid]) => {
  const isFormFilled = !some(data, isEmpty);
  emit(EVENTS.status, isFormFilled && isValid);
}, { immediate: true });


return (_ctx: any,_cache: any) => {
  const _component_ui_text_input = _resolveComponent("ui-text-input")!
  const _component_ui_select = _resolveComponent("ui-select")!
  const _component_ui_validate = _resolveComponent("ui-validate")!
  const _directive_validate = _resolveDirective("validate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!__props.isStandAlone)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_unref(translate)('clientDriverLicence.documentType')) + ": ", 1))
      : _createCommentVNode("", true),
    _createVNode(_component_ui_validate, {
      onStatus: _cache[4] || (_cache[4] = ({ detail }) => isValidForm.value = detail.isValid)
    }, {
      default: _withCtx(() => [
        (!_unref(initialLicenceData).licenseId)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _withDirectives(_createVNode(_component_ui_text_input, {
                label: _unref(translate)('clientDriverLicence.documentType'),
                onChangevalue: _cache[0] || (_cache[0] = ({ detail }) => handleValueChange('licenseId', detail))
              }, null, 8, ["label"]), [
                [
                  _directive_validate,
                  {
            isRequired: {
              message: _unref(translate)('validationErrors.requiredField')
            }
          },
                  void 0,
                  { input: true }
                ]
              ])
            ]))
          : _createCommentVNode("", true),
        (!_unref(initialLicenceData).licenseType)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _withDirectives(_createVNode(_component_ui_text_input, {
                label: _unref(translate)('clientDriverLicence.class'),
                onChangevalue: _cache[1] || (_cache[1] = ({detail}) => handleValueChange('licenseType', detail))
              }, null, 8, ["label"]), [
                [
                  _directive_validate,
                  {
            isRequired: {
              message: _unref(translate)('validationErrors.requiredField')
            }
          },
                  void 0,
                  { input: true }
                ]
              ])
            ]))
          : _createCommentVNode("", true),
        (!_unref(initialLicenceData).licenseExpeditionCountry)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _withDirectives(_createVNode(_component_ui_select, {
                label: _unref(translate)('clientDriverLicence.expeditionCountry'),
                options: countriesOptions.value,
                onSelectoption: _cache[2] || (_cache[2] = ({detail}) => handleValueChange('licenseExpeditionCountry', detail))
              }, null, 8, ["label", "options"]), [
                [
                  _directive_validate,
                  {
            isRequired: {
              message: _unref(translate)('validationErrors.requiredField')
            }
          },
                  void 0,
                  { input: true }
                ]
              ])
            ]))
          : _createCommentVNode("", true),
        (!_unref(initialLicenceData).drivingLicenseExpirationDate)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _withDirectives(_createVNode(DatePicker, {
                label: _unref(translate)('clientDriverLicence.expirationDate'),
                "onUpdate:date": _cache[3] || (_cache[3] = date => handleValueChange('drivingLicenseExpirationDate', date))
              }, null, 8, ["label"]), [
                [
                  _directive_validate,
                  {
            isRequired: {
              message: _unref(translate)('validationErrors.requiredField')
            }
          },
                  void 0,
                  { input: true }
                ]
              ])
            ]))
          : _createCommentVNode("", true)
      ], undefined, true),
      _: 1
    })
  ]))
}
}

})